import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getImage, type PropertyImage } from '../data/images';
import { Reveal } from './Reveal';
interface BedroomCard {
  image: PropertyImage | undefined;
  titleEn: string;
  titleEs: string;
  bodyEn: string;
  bodyEs: string;
}
const CARDS: BedroomCard[] = [{
  image: getImage('primaryBedroom'),
  titleEn: 'Primary Suite',
  titleEs: 'Habitación Principal',
  bodyEn: 'A comfortable private retreat with generous space, natural light and a peaceful atmosphere.',
  bodyEs: 'Un refugio privado y confortable, con buen espacio, luz natural y un ambiente tranquilo.'
}, {
  image: getImage('guestBedroom'),
  titleEn: 'Guest Bedroom',
  titleEs: 'Habitación de Invitados',
  bodyEn: 'A welcoming bedroom prepared for family members and visitors.',
  bodyEs: 'Una habitación acogedora preparada para familiares y visitantes.'
}, {
  image: getImage('bunkBedroom'),
  titleEn: 'Bunk Room',
  titleEs: 'Habitación con Literas',
  bodyEn: 'A flexible sleeping space designed for families and younger guests.',
  bodyEs: 'Un espacio flexible diseñado para familias y huéspedes más jóvenes.'
}];
export function BedroomsSection() {
  const {
    lang,
    t
  } = useLanguage();
  // Cards without a supplied photograph stay hidden until the correct image exists.
  const cards = CARDS.filter(card => Boolean(card.image));
  return <section id="bedrooms" className="w-full bg-ivory py-20 lg:py-28" data-id="element-78" data-mp="2fgutkd4fsmx9">
      <div className="mx-auto max-w-editorial px-5 lg:px-8" data-id="element-79" data-mp="2ka60sfd5v5pp">
        <Reveal data-id="element-80" data-mp="26hpu94l1wpk1">
          <div className="max-w-2xl" data-id="element-81" data-mp="26i9bej2vn9x0">
            <h2 className="font-display text-[34px] font-semibold uppercase leading-[1.02] text-midnight sm:text-[44px] lg:text-[52px]" data-id="element-82" data-mp="26jan8prpw0fs">
              {t('Room for Everyone', 'Espacio para Todos')}
            </h2>
            <div className="gold-rule mt-6 w-24" data-id="element-83" data-mp="1wkblzs9a772t" />
            <p className="mt-6 text-[15px] leading-relaxed text-ink/80 lg:text-base" data-id="element-84" data-mp="21iwe14edqkg6">
              {t('Three thoughtfully furnished bedrooms provide comfortable and flexible accommodations for owners, family members and guests.', 'Tres habitaciones cuidadosamente amobladas ofrecen espacios cómodos y flexibles para propietarios, familiares e invitados.')}
            </p>
          </div>
        </Reveal>

        <ul className="mt-12 grid gap-8 md:grid-cols-3" data-id="element-85" data-mp="3peb0uputa8ma">
          {cards.map((card, index) => <Reveal as="li" key={card.titleEn} delay={index * 0.05} className="flex h-full flex-col" data-id="element-86" data-mp="pz665rw481so" data-mpi={index}>
              <div className="h-[240px] w-full overflow-hidden sm:h-[300px] lg:h-[340px]" data-id="element-87" data-mp="lxufdj1i9aiw">
                <img src={card.image!.src} alt={lang === 'en' ? card.image!.altEn : card.image!.altEs} width={card.image!.width} height={card.image!.height} loading="lazy" decoding="async" className="h-full w-full object-cover" style={{
              objectPosition: card.image!.objectPosition
            }} data-id="element-88" data-mp="h2ou8mfxfzvv" />
              </div>
              <h3 className="mt-6 font-display text-[22px] font-medium uppercase tracking-[0.06em] text-midnight" data-id="element-89" data-mp="2rnxra0jlbui4">
                {lang === 'en' ? card.titleEn : card.titleEs}
              </h3>
              <div className="gold-rule mt-4 w-12" data-id="element-90" data-mp="31dr3n3rk4dnf" />
              <p className="mt-4 text-[14px] leading-relaxed text-ink/75" data-id="element-91" data-mp="35eb2cbrs3pbo">
                {lang === 'en' ? card.bodyEn : card.bodyEs}
              </p>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}